<template>
  <div>
    <!-- 标题 -->
    <div class="instance-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountType }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.region }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/WebApplicationFirewallMonitor">{{
          $t("alarms.WebApplicationFirewall.WebApplicationFirewall")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="instance-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-if="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountType == 'AWS'
          ? awsList
          : this.$route.query.accountName == 'Aliyun-test'
          ? alyList
          : azureList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil";
export default {
  name: "InatanceWebApplicationFirewall",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // AWS折线图
      awsList: [],
      // 阿里云折线图
      alyList: [
        {
          id: "qps",
          title: this.$t("alarms.WebApplicationFirewall.line.Qps"),
        },
        {
          id: "qpsRatio",
          title: this.$t("alarms.WebApplicationFirewall.line.QpsRatio"),
        },
        {
          id: "qpsRatioDown",
          title: this.$t("alarms.WebApplicationFirewall.line.QpsRatioDown"),
        },
      ],
      // azure折线图
      azureList: [],
      isAWS: false,
      isALY: false,
      timeType: 0,
      timeList: [],
      id: "",
      accountId: "",
      name: "",
      period: "",
      accountId: "",
      accountType: "",
      accountName: "",
      region: "",
      monitorModule: "",
      natGatewayId: "",
      instanceId: "",
      // echarts实例
      qpsOptions: {},
      qpsRatioOptions: {},
      qpsRatioDownOption: {},
      chartQps: "",
      chartQpsRatio: "",
      chartQpsRatioDown: "",
      //Aliyun数组
      qps: [],
      qpsRatio: [],
      qpsRatioDown: [],
      xaxisData: [],
    };
  },
  mounted: function () {
    if (this.$route.query.accountType == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {});
    } else if (this.$route.query.accountName == "Aliyun-test") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartQps.resize();
        self.chartQpsRatio.resize();
        self.chartQpsRatioDown.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountType == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountType == "Azure") {
      this.isAzure = true;
      this.checkAzureCloudVMDiskStatistics();
    } else if (this.$route.query.accountName == "Aliyun-test") {
      this.isALY = true;
      this.checkAliRedisStatistics();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "qps") {
            var optionFll = this.qpsOption;
          } else if (item.id == "qpsRatio") {
            var optionFll = this.qpsRatioOption;
          } else if (item.id == "qpsRatioDown") {
            var optionFll = this.qpsRatioDownOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    // Aliyun折线图
    checkAliRedisStatistics: function () {
      this.$api.cloudWatch
        .checkALIWafIndex({
          timeHorizon: this.timeType,
          accountId: this.$route.query.accountId,
          instanceId: this.$route.query.instanceId,
          monitorModule: 44,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.xaxisData = res.data.xaxisData;
          this.qps = res.data.qps;
          this.qpsRatio = res.data.qpsRatio;
          this.qpsRatioDown = res.data.qpsRatioDown;
          this.allAws();
        });
    },
    changeTimeType: function () {
      this.checkAWSEipStatistics();
    },
    changeTimeTypeALY: function () {
      this.checkAliRedisStatistics();
    },
    /******************所有折线图********************************/
    allAws: function () {
      this.qpsLine();
      this.qpsRatioLine();
      this.qpsRatioDownLine();
    },
    /*************Aliyun折线图*****************************/
    //QPS
    qpsLine: function () {
      this.chartQps = this.$echarts.init(document.getElementById("qps"));
      this.qpsOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.WebApplicationFirewall.line.Qps")],
        },
        series: [
          {
            name: this.$t("alarms.WebApplicationFirewall.line.Qps"),
            type: "line",
            data: this.qps,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartQps.setOption(this.qpsOption);
    },

    //qpsRatio
    qpsRatioLine: function () {
      this.chartQpsRatio = this.$echarts.init(
        document.getElementById("qpsRatio")
      );
      this.qpsRatioOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.WebApplicationFirewall.line.QpsRatio")],
        },
        series: [
          {
            name: this.$t("alarms.WebApplicationFirewall.line.QpsRatio"),
            type: "line",
            data: this.qpsRatio,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartQpsRatio.setOption(this.qpsRatioOption);
    },
    //qpsRatioDown
    qpsRatioDownLine: function () {
      this.chartQpsRatioDown = this.$echarts.init(
        document.getElementById("qpsRatioDown")
      );
      this.qpsRatioDownOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.WebApplicationFirewall.line.QpsRatioDown")],
        },
        series: [
          {
            name: this.$t("alarms.WebApplicationFirewall.line.QpsRatioDown"),
            type: "line",
            data: this.qpsRatioDown,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartQpsRatioDown.setOption(this.qpsRatioDownOption);
    },

    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
      this.accountType = this.$route.query.accountType;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.instanceId = this.$route.query.instanceId;
      this.$router.push({
        path: "/monitor/WebApplicationFirewallDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          accountType: this.accountType,
          accountName: this.accountName,
          name: this.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-8 {
  margin-bottom: 20px;
}
.instance-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/webApplicationFirewall/instance_dashboard/InstanceWebApplicationFirewall.vue